import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Optional
} from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxGroupComponent } from './checkbox-group.component';

@Component({
  selector: 'mtg-checkbox',
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ],
})
export class CheckboxComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private control: AbstractControl;
  private onTouch: () => void;
  private onChange: (value) => void;
  @Input()
  formControl: FormControl;
  @Input()
  formControlName: string;
  @Input()
  value: any = true;
  @Input()
  reverse: boolean;
  checked: boolean;

  get isReverse(): boolean {
    return this.reverse || this.checkboxGroupComponent?.reverse;
  }

  @HostBinding('class.checkbox-container')
  get defaultClass() {
    return true;
  }

  constructor(
    @Optional() private parentFormGroup: FormGroupDirective,
    @Optional() private checkboxGroupComponent: CheckboxGroupComponent,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    if (this.parentFormGroup) {
      this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
    }
    if (this.checkboxGroupComponent) {
      this.checked = (this.checkboxGroupComponent.value || []).indexOf(this.value) > -1;
      this.checkboxGroupComponent.addCheckbox(this);
    }
  }

  ngOnDestroy(): void {
    if (this.checkboxGroupComponent) {
      this.checkboxGroupComponent.removeCheckbox(this);
    }
  }

  writeValue(obj: any): void {
    this.checked = obj === this.value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  changeValue(checked: boolean, fromCheckboxGroup?: boolean): void {
    this.checked = checked;
    if (this.checkboxGroupComponent && !fromCheckboxGroup) {
      this.checkboxGroupComponent.onItemChanged(this.value, this.checked);
    }
    if (fromCheckboxGroup) {
      this.cdr.detectChanges();
    }

    if (this.onTouch) {
      this.onTouch();
    }
    if (this.onChange) {
      this.onChange(this.checked ? this.value : null);
    }
  }
}
